import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsDelete = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 0C4.84315 0 3.5 1.34315 3.5 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H15C15.5523 5 16 4.55228 16 4C16 3.44772 15.5523 3 15 3H12.5C12.5 1.34315 11.1569 0 9.5 0H6.5ZM6.5 2C5.94772 2 5.5 2.44772 5.5 3H10.5C10.5 2.44772 10.0523 2 9.5 2H6.5Z"
          fill="inherit"
        />
        <path
          d="M6 9.5C6.55228 9.5 7 9.94771 7 10.5V15.5C7 16.0523 6.55228 16.5 6 16.5C5.44772 16.5 5 16.0523 5 15.5V10.5C5 9.94771 5.44772 9.5 6 9.5Z"
          fill="inherit"
        />
        <path
          d="M10 9.5C10.5523 9.5 11 9.94771 11 10.5V15.5C11 16.0523 10.5523 16.5 10 16.5C9.44771 16.5 9 16.0523 9 15.5V10.5C9 9.94771 9.44771 9.5 10 9.5Z"
          fill="inherit"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 6C1.44772 6 1 6.44772 1 7L1 13.0706C0.999966 14.4247 0.999936 15.5413 1.11875 16.4251C1.2435 17.3529 1.51547 18.1723 2.17158 18.8284C2.82768 19.4845 3.64711 19.7565 4.57494 19.8812C5.4587 20.0001 6.57531 20 7.92943 20H8.07058C9.4247 20 10.5413 20.0001 11.4251 19.8812C12.3529 19.7565 13.1723 19.4845 13.8284 18.8284C14.4845 18.1723 14.7565 17.3529 14.8813 16.4251C15.0001 15.5413 15 14.4247 15 13.0706L15 7C15 6.44772 14.5523 6 14 6H2ZM3 13V8H13V13C13 14.4425 12.9979 15.4237 12.8991 16.1586C12.8042 16.8646 12.6368 17.1916 12.4142 17.4142C12.1916 17.6368 11.8646 17.8042 11.1586 17.8991C10.4238 17.9979 9.44249 18 8 18C6.55752 18 5.57625 17.9979 4.84143 17.8991C4.13538 17.8042 3.80836 17.6368 3.58579 17.4142C3.36322 17.1916 3.19585 16.8646 3.10092 16.1586C3.00213 15.4237 3 14.4425 3 13Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default PdsDelete;
